export const ARTICLE_OPTIONS_CHANGED_EVENT = 'ft5.pdp.articleOptionsChanged';
